import React, {useState, useEffect} from 'react';
import QuestionDetails from './questionDetails';
import {useParams} from 'react-router'
import MainContractor from './mainContractor';
import MainDealer from './mainDealer';
import Footer from '../components/footer';
import CircularProgress from '@material-ui/core/CircularProgress';
import codeInvalid from '../assets/images/codeInvalid.png'
import codeUsed from '../assets/images/codeUsed.png'
import '../styling/containerStyles.css'

export const MainRaincoatNeo: React.FC = () =>{

    const [questionType, setQuestionType] = useState('')
    const [loading, setLoading] = useState(false)
    const [codeScanStatus, setCodeScanStatus] = useState(true)
    const [codeScanStatusCode, setCodeScanStatusCode] = useState(0)
    const [paymentStatus, setPaymentStatus] = useState('')
    const [paymentMessage, setPaymentMessage] = useState('')

    const HOST = process.env.REACT_APP_HOST; 
    const API = process.env.REACT_APP_API;
    const axios = require('axios').default;

    interface ParamTypes {
        couponId: string,
    }
  
    const couponCode = useParams<ParamTypes>().couponId

    const urlParams = new URLSearchParams(window.location.search);
    const dealerPhone = urlParams.get('dealer');

    const handleContractorType = (arg: any) => {
        setQuestionType(arg.profession)
    }

    useEffect(() => {
      const checkinitial = async () => {
        const couponStatus = await checkCode();
        if(dealerPhone && !localStorage.getItem('IS_DEALER_LOGIN') && couponStatus?.resultCode === 0) {
          setQuestionType('Dealer');
        }
      }
      checkinitial();
    }, []);

    const checkCode = async() => {
        setLoading(true)
        return axios
        .post(
          `${HOST}${API}check-coupon-code/`,
          {
            code: couponCode,
            user: 'CWC'
          },
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        )
        .then((res: any) => {
          const data = res.data.data
          if(data.resultCode === 0){
          }
          else{
            setCodeScanStatusCode(data.resultCode)
            setCodeScanStatus(false);
          }
          setLoading(false)
          return data;
        })
        .catch((err: any) => {
          const amtInvalid = err.response.data;
          if(amtInvalid.amount_invalid === true) {
            setPaymentStatus('AMOUNTINVALID')
            setPaymentMessage(amtInvalid.message)
          }
          if(amtInvalid.user_blocked === true) {
            setPaymentStatus('BLOCKUSER')
            setPaymentMessage(amtInvalid.message)
          }
          setLoading(false)
            return err;
        });
      }

    if(questionType === "Contractor" || questionType === "") {
        localStorage.removeItem('x-access-token-dealer');
        localStorage.removeItem('x-refresh-token-dealer');
        localStorage.removeItem('dealer_profession');
    }
        return (      
            <>
                {
                    loading &&
                    <div className='home popup_logout'>
                      <CircularProgress />
                      <Footer />
                    </div>
                }
                {
                  !codeScanStatus && !loading && codeScanStatusCode === 901 &&
                  <div className="home popup_logout">
                      <div className='home'>
                          <div className='verifyNumberPage'>
                          <img src={codeUsed} alt='code valid' className='codeValidImg'/>                             
                          </div>
                          <Footer />
                      </div>
                  </div>
                }
                {
                    !codeScanStatus && !loading && codeScanStatusCode !== 901 &&
                    <div className="home popup_logout">
                        <div className='home'>
                            <div className='verifyNumberPage'>
                            <img src={codeInvalid} alt='code valid' className='codeValidImg'/>                             
                            </div>
                            <Footer />
                        </div>
                    </div>
                }

                {
                    paymentStatus==='BLOCKUSER' && !loading &&
                    <div className="home popup_logout">
                    <div className="suc" id="cust box">
                        <div className='failure_transaction validation_failure'>
                            <h2>{paymentMessage}</h2>
                        </div>
                    </div>
                    <Footer />
                    </div>
                }

                {
                    paymentStatus==='AMOUNTINVALID' && !loading &&
                    <div className="home popup_logout">
                    <div className="suc" id="cust box">
                        <div className='failure_transaction validation_failure'>
                            <h2>{paymentMessage}</h2>
                        </div>
                    </div>
                    <Footer />
                    </div>
                }

                {
                    questionType === "" && !loading && codeScanStatus && paymentStatus === "" ?
                    <div className='home popup_logout'>
                        <QuestionDetails handleContractorType={handleContractorType} />
                        <Footer />
                    </div>
                    :
                    questionType === "Contractor" ?
                    <MainContractor questionType={questionType} />
                    :
                    questionType === "Dealer" &&
                    <MainDealer questionType={questionType} />
                }

            </>             
        )
    }

export default MainRaincoatNeo